import { apiFetch } from './apiFetch';

const API_BASE = process.env.REACT_APP_API_URL;

export async function fetchKeyVersion() {
  const res = await apiFetch(`${API_BASE}/admin/encryption/key-version`);
  return res.json();
}

export async function rotateKeyVersion(keyVersion) {
  const res = await apiFetch(`${API_BASE}/admin/encryption/rotate`, {
    method: 'POST',
    body: JSON.stringify({ keyVersion })
  });
  return res.json();
}

export async function rewrapKeyVersion(fromVersion, toVersion) {
  const res = await apiFetch(`${API_BASE}/admin/encryption/rewrap`, {
    method: 'POST',
    body: JSON.stringify(toVersion === undefined ? { fromVersion } : { fromVersion, toVersion })
  });
  return res.json();
}
